var React = require('react');

function Adjust (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M504 256c0 137-111 248-248 248V8c137 0 248 111 248 248z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M256 8v496C119 504 8 393 8 256S119 8 256 8z","className":"fa-primary","key":2})]);
}

Adjust.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Adjust;

Adjust.default = Adjust;
